import { cn } from '@/src/lib/utils/command';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-primary/30 animate-pulse rounded-md pb-1 dark:bg-slate-800', className)}
      {...props}
    />
  );
}

export { Skeleton };
